import { Ref } from 'react';
import { Settings } from '@fsd/shared/ui/icons/settings';
import styles from './temp_style/button-setting.module.scss';

interface ButtonSettingProps {
  onClick: () => void;
  buttonRef?: Ref<HTMLButtonElement>;
  className?: string;
}

export const ButtonSetting = ({
  onClick,
  buttonRef,
  className,
}: ButtonSettingProps) => {
  return (
    <button
      ref={buttonRef}
      className={`${styles.buttonSetting} ${className || ''}`}
      onClick={onClick}
    >
      <Settings />
    </button>
  );
};
